  <button (click)="openDocDrawer($event)"
        [ngClass]="getButtonClasses()"
        [nz-tooltip]="shouldShowExpirationAlert() && getTooltipText() ? docTooltipTmpl : null" [nzTooltipOverlayClassName]="'tp-small'"
        [nzTooltipOverlayStyle]="{'max-width': 'fit-content', 'min-height': '24px'}"
        nz-button nzSize="small" nzType="default">
  <app-st-icon class="prefix"
               [name]="getIconName()"></app-st-icon>
  <span>{{ showName ? document.name : getDocumentTypeName(document.documentTypeId) }}</span>
  <app-st-icon class="sufix" name="open_in_new"></app-st-icon>

  <ng-template #docTooltipTmpl>
    <span class="text-semibold" style="line-height: 1; font-size: 14px">
      {{getTooltipText()}}</span>
  </ng-template>
</button>


